// Maps both legacy rule type values (`override`, `general`, `compact`,
// `rollout_link`) and the current ones used in label values to user-facing
// labels.
const RULE_TYPE_DISPLAY_NAMES: Record<string, string> = {
  individual_targeting: 'Individual targeting',
  override: 'Individual targeting',
  conditional_targeting: 'Conditional targeting',
  general: 'Conditional targeting',
  compact: 'Conditional targeting',
  rollout: 'Rollout',
  rollout_link: 'Rollout',
  abtest: 'A/B test',
  workflow: 'Experiment',
};

export const getRuleTypeDisplayName = (ruleType: string): string =>
  RULE_TYPE_DISPLAY_NAMES[ruleType] ?? '';
